import { MVTLayer } from "deck.gl"
import { _TerrainExtension as TerrainExtension, DataFilterExtension } from "@deck.gl/extensions"
import { generateUrlGeoserverVector, hideLoading, showLoading } from "../core/utils"

export function AdmBounds ( workspace, layerName, is3D, opacity, zoom, color ) {
    const dataSource = generateUrlGeoserverVector(workspace, layerName)
    function lightenColor([r, g, b, alpha], percent) {
        const p = percent / 100;
        const newR = Math.min(255, r + (255 - r) * p);
        const newG = Math.min(255, g + (255 - g) * p);
        const newB = Math.min(255, b + (255 - b) * p);
        return [newR, newG, newB, alpha];
    }

    return [
                new MVTLayer({
                    id: 'sumatraAdminArea1Hover',
                    data: dataSource,
                    onTileLoad: showLoading,
                    onViewportLoad: hideLoading,
                    opacity: 0,
                    stroked: true,
                    filled: true,
                    getLineColor: [0, 0, 0, 0],
                    getFillColor: [0, 0, 0, 0],
                    getFilterValue: d => {
                       ;
                        return Number.isFinite(d.properties.level) ? d.properties.level :  console.log(d.properties.level);
                    },
                    filterRange: [1, 1],
                    filterSoftRange: [1, 1],
                    extensions: is3D
                        ? [new DataFilterExtension({ filterSize: 1 }), new TerrainExtension()]
                        : [new DataFilterExtension({ filterSize: 1 })],
                    terrainDrawMode: is3D ? 'offset' : '',
                    getLineWidth: 1000.0,
                    pickable: true,
                    visible: zoom < 7.5
                }),
                new MVTLayer({
                    id: 'sumatraAdminArea1',
                    data: dataSource,
                    onTileLoad: showLoading,
                    onViewportLoad: hideLoading,
                    uniqueIdProperty: 'GID',
                    opacity: opacity / 100,
                    stroked: true,
                    filled: true,
                    getLineColor: [255, 121, 91, 100],
                    getFillColor: [255, 121, 91, 80],
                    getFilterValue: d => d.properties.level? d.properties.level : 0,
                    filterRange: [1, 1],
                    filterSoftRange: [1, 1],
                    extensions: is3D
                        ? [new DataFilterExtension({ filterSize: 1 }), new TerrainExtension()]
                        : [new DataFilterExtension({ filterSize: 1 })],
                    terrainDrawMode: is3D ? 'drape' : '',
                    getLineWidth: 1000.0,
                    pickable: true,
                    autoHighlight: true,
                    highlightColor: lightenColor([255, 121, 91, 150], 20),
                    visible: zoom < 7.5
                }),
    
                new MVTLayer({
                    id: 'sumatraAdminArea2Hover',
                    data: dataSource,
                    onTileLoad: showLoading,
                    onViewportLoad: hideLoading,
                    opacity: 0,
                    stroked: true,
                    filled: true,
                    getLineColor: [120, 120, 120],
                    getFillColor: [123, 152, 255, 50],
                    getFilterValue: d => d.properties.level? d.properties.level : 0,
                    filterRange: [2, 2],
                    filterSoftRange: [2, 2],
                    extensions: is3D
                        ? [new DataFilterExtension({ filterSize: 1 }), new TerrainExtension()]
                        : [new DataFilterExtension({ filterSize: 1 })],
                    terrainDrawMode: is3D ? 'offset' : '',
                    getLineWidth: 500 ,
                    pickable: true,
                    visible: zoom >= 7.5 && zoom < 9.5
                }),
            
                new MVTLayer({
                    id: 'sumatraAdminArea2',
                    data: dataSource,
                    uniqueIdProperty: 'GID',
                    onTileLoad: showLoading,
                    onViewportLoad: hideLoading,
                    opacity: opacity / 100,
                    stroked: true,
                    filled: true,
                    getLineColor: [123, 152, 255, 100],
                    getFillColor:[123, 152, 255, 50],
                    getFilterValue: d => d.properties.level? d.properties.level : 0,
                    filterRange: [2, 2],
                    filterSoftRange: [2, 2],
                    extensions: is3D
                        ? [new DataFilterExtension({ filterSize: 1 }), new TerrainExtension()]
                        : [new DataFilterExtension({ filterSize: 1 })],
                    terrainDrawMode: is3D ? 'drape' : '',
                    getLineWidth: 500 ,
                    pickable: true,
                    autoHighlight: true,
                    highlightColor: lightenColor([123, 152, 255, 150], 20),
                    visible: zoom >= 7.5 && zoom < 9.5
                }),
    
                new MVTLayer({
                    id: 'sumatraAdminArea3Hover',
                    data: dataSource,
                    onTileLoad: showLoading,
                    onViewportLoad: hideLoading,
                    opacity: 0,
                    stroked: true,
                    filled: true,
                    getLineColor: [123, 216, 255, 100],
                    getFillColor: [123, 216, 255, 50],
                    getFilterValue: d => d.properties.level? d.properties.level : 0,
                    filterRange: [3, 3],
                    filterSoftRange: [3, 3],
                    extensions: is3D
                        ? [new DataFilterExtension({ filterSize: 1 }), new TerrainExtension()]
                        : [new DataFilterExtension({ filterSize: 1 })],
                    terrainDrawMode: is3D ? 'offset' : '',
                    getLineWidth: 100,
                    lineWidthMinPixels: 1.0,
                    pickable: true,
                    visible: zoom >= 9.5 && zoom < 12
                }),
    
                new MVTLayer({
                    id: 'sumatraAdminArea3',
                    data: dataSource,
                    uniqueIdProperty: 'GID',
                    onTileLoad: showLoading,
                    onViewportLoad: hideLoading,
                    opacity: opacity / 100,
                    stroked: true,
                    filled: true,
                    getLineColor: [123, 216, 255, 100],
                    getFillColor: [123, 216, 255, 50],
                    getFilterValue: d => d.properties.level? d.properties.level : 0,
                    filterRange: [3, 3],
                    filterSoftRange: [3, 3],
                    extensions: is3D
                        ? [new DataFilterExtension({ filterSize: 1 }), new TerrainExtension()]
                        : [new DataFilterExtension({ filterSize: 1 })],
                    terrainDrawMode: is3D ? 'drape' : '',
                    getLineWidth: 100,
                    lineWidthMinPixels: 1.0,
                    pickable: true,
                    autoHighlight: true,
                    highlightColor: lightenColor([123, 216, 255, 150], 20),
                    visible: zoom >= 9.5 && zoom < 12
                }),
                
                
                new MVTLayer({
                    id: 'sumatraAdminArea4Hover',
                    data: dataSource,
                    onTileLoad: showLoading,
                    onViewportLoad: hideLoading,
                    opacity: 0,
                    stroked: true,
                    filled: true,
                    getLineColor:[120, 120, 120, 100],
                    getFillColor: [120, 120, 120, 50],
                    getFilterValue: d => d.properties.level? d.properties.level : 0,
                    filterRange: [4, 4],
                    filterSoftRange: [4, 4],
                    terrainDrawMode: is3D ? 'offset' : '',
                    extensions: is3D
                        ? [new DataFilterExtension({ filterSize: 1 }), new TerrainExtension()]
                        : [new DataFilterExtension({ filterSize: 1 })],
                    getLineWidth: 90,
                    lineWidthMinPixels: 1.0,
                    pickable: true,
                    visible: zoom >= 12
                }),
    
                new MVTLayer({
                    id: 'sumatraAdminArea4',
                    data: dataSource,
                    uniqueIdProperty: 'GID',
                    onTileLoad: showLoading,
                    onViewportLoad: hideLoading,
                    opacity: opacity / 100,
                    stroked: true,
                    filled: true,
                    getLineColor:[120, 120, 120, 100],
                    getFillColor: [120, 120, 120, 50],
                    getFilterValue: d => d.properties.level? d.properties.level : 0,
                    filterRange: [4, 4],
                    filterSoftRange: [4, 4],
                    terrainDrawMode: is3D ? 'drape' : '',
                    extensions: is3D
                        ? [new DataFilterExtension({ filterSize: 1 }), new TerrainExtension()]
                        : [new DataFilterExtension({ filterSize: 1 })],
                    getLineWidth: 90,
                    lineWidthMinPixels: 1.0,
                    pickable: true,
                    autoHighlight: true,
                    highlightColor: lightenColor([120, 120, 120, 150], 20),
                    visible: zoom >= 12
                }),
            ]
}